import { IDeliverySettings } from '@/models/deliverySettings.model';
import { DeliverySettingsFormFields } from './types';

export const getDeliverySettingsInitialValues = (deliverySettings: IDeliverySettings | null) => {
  return {
    [DeliverySettingsFormFields.FREE_DELIVERY]: {
      [DeliverySettingsFormFields.IS_ENABLED]: false,
      [DeliverySettingsFormFields.MIN_ORDER_AMOUNT]: '',
      [DeliverySettingsFormFields.EXCLUDED_STATES_USA]: [],
      [DeliverySettingsFormFields.EXCLUDED_STATES_CANADA]: [],
      [DeliverySettingsFormFields.POPUP_TITLE]: '',
      [DeliverySettingsFormFields.POPUP_DESCRIPTION]: '',
      ...deliverySettings?.freeDelivery,
    },
    [DeliverySettingsFormFields.UPS_DELIVERY]: {
      [DeliverySettingsFormFields.IS_ENABLED]: false,
      [DeliverySettingsFormFields.PRICE]: '',
      [DeliverySettingsFormFields.EXCLUDED_STATES_USA]: [],
      [DeliverySettingsFormFields.EXCLUDED_STATES_CANADA]: [],
      ...deliverySettings?.upsDelivery,
    },
  };
};
